/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_Voice_OverInputs */



/**
* | output |
* | --- |
* | "Voice Over" |
*
* @param {Audio_Description_Export_Loudness_Voice_OverInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_voice_over = /** @type {((inputs?: Audio_Description_Export_Loudness_Voice_OverInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_Voice_OverInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voix off")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voice-Over")
	if (locale === "it") return /** @type {LocalizedString} */ ("Voce fuori campo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Озвучка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Voz en off")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("旁白")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ナレーション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पार्श्व स्वर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Narração")
	return /** @type {LocalizedString} */ ("Voice Over")
});